<template>
  <v-autocomplete
    :value="value"
    :items="devices"
    :multiple="true"
    chips
    small-chips
    deletable-chips
    item-text="name"
    item-value="id"
    :label="$trans('v2.i2m_standard-types.devices')"
    @change="emitInput"
  />
</template>

<script>

export default {
  props: {
    value: {
      required: true,
      type: Array,
    },
    devices: {
      required: true,
      type: Array,
    },
  },
  methods: {
    /**
     * Emit input current state
     * @param {array} devicesIds Array of devices ids
     */
    emitInput(devicesIds) {
      this.$emit('input', devicesIds);
    },
  },
};
</script>
